import { isPlatform } from "@ionic/react";

/**
 * Se definen las constantes globales
 */
export const isDesktop = !(isPlatform("capacitor") || isPlatform("cordova"));
export const isIos = isPlatform("ios");
export const isAndroid = isPlatform("android");
